import {

  CREATE_RESERVATION_REQUEST,
  CREATE_RESERVATION_SUCCESS,
  CREATE_RESERVATION_FAIL,



  ALL_RESERVATIONS_REQUEST,
  ALL_RESERVATIONS_SUCCESS,
  ALL_RESERVATIONS_FAIL,


  UPDATE_RESERVATION_STATUS_REQUEST,
  UPDATE_RESERVATION_STATUS_SUCCESS,
  UPDATE_RESERVATION_STATUS_FAIL,


  SINGLE_RESERVATION_REQUEST,
  SINGLE_RESERVATION_SUCCESS,
  SINGLE_RESERVATION_FAIL,


} from "../constants/reservationConstants";

import {
  BLOCK_PRODUCT_REQUEST,
  BLOCK_PRODUCT_SUCCESS,
  BLOCK_PRODUCT_FAIL,
} from "../constants/productConstants";

import api from "../../api";



export const createReservationActions = (reservation) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_RESERVATION_REQUEST });

    const { data } = await api.post("/api/v1/reserve-product", reservation,
      { headers: { "Content-Type": "application/json" } }
    );

    dispatch({
      type: CREATE_RESERVATION_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: CREATE_RESERVATION_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};
export const blockProductActions = (productData) => async (dispatch) => {
  try {
    dispatch({ type: BLOCK_PRODUCT_REQUEST });

    const { data } = await api.put("/api/v1/block-product", productData,
      { headers: { "Content-Type": "application/json" } }
    );

    dispatch({
      type: BLOCK_PRODUCT_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: BLOCK_PRODUCT_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};

export const allReservationsAction = (queryParams = {}) => async (dispatch) => {
  try {
    dispatch({ type: ALL_RESERVATIONS_REQUEST })

    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `/api/v1/all-reservations?${queryString}` : `/api/v1/all-reservations`;

    const { data } = await api.get(url);
    dispatch({
      type: ALL_RESERVATIONS_SUCCESS,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: ALL_RESERVATIONS_FAIL,
      payload: error.response?.data?.message || error.message,
    })
  }
}



export const updateReservationStatusActions = (reservation) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_RESERVATION_STATUS_REQUEST });

    const { data } = await api.put("/api/v1/update-reservation-status", reservation,
      { headers: { "Content-Type": "application/json" } }
    );

    dispatch({
      type: UPDATE_RESERVATION_STATUS_SUCCESS,
      payload: data.message
    });

  } catch (error) {
    dispatch({
      type: UPDATE_RESERVATION_STATUS_FAIL,
      payload: error.response?.data?.message || error.message
    });
  }
};


export const singleReservationAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: SINGLE_RESERVATION_REQUEST });

    console.log("ahmad")

    const { data } = await api.get(`/api/v1/single-reservation?reservation_id=${id}`);

    dispatch({
      type: SINGLE_RESERVATION_SUCCESS,
      payload: data,
    });

  } catch (error) {
    dispatch({
      type: SINGLE_RESERVATION_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
